<!--
      Generic modal for global duplicate user in App
    <UserAlreadyInviteModal />
 -->
<script setup lang="ts">
import { ALAvatar, ALButton, ALModal } from '@af-lib/vue-ui';
import { computed } from 'vue';

import { useUserAlreadyInviteModalStore } from './UserAlreadyInviteModalStore';

const globalInfoModalStore = useUserAlreadyInviteModalStore();

const show = computed({
  get: () => globalInfoModalStore.getShowModal,
  set: value => {
    if (!value) {
      close();
    }
  }
});

// If a close action is set on the store, we execute this before resetting store and closing the modal
function close() {
  if (globalInfoModalStore.getCloseAction) {
    globalInfoModalStore.getCloseAction();
  }
  globalInfoModalStore.$reset();
}
</script>
<template>
  <Teleport to="#af-app">
    <ALModal
      v-model="show"
      :icon="globalInfoModalStore.getType"
      :title="globalInfoModalStore.getTitle"
      @update:modelValue="close"
    >
      <template #content>
        <div class="grid gap-[16px]">
          <p v-if="globalInfoModalStore.getContent?.descriptions" class="text-body3-light">
            {{ globalInfoModalStore.getContent?.descriptions }}
          </p>
          <ul class="grid gap-[8px]">
            <li
              v-for="item in globalInfoModalStore.getContent?.items"
              :key="item"
              class="flex items-center gap-[12px] p-3 rounded border border-af-grey-300"
            >
              <ALAvatar class="me-3" size="xs" />
              <p class="text-body3-medium">
                {{ item }}
              </p>
            </li>
          </ul>
        </div>
      </template>
      <template #footer>
        <ALButton type="tertiary" :label="$t('general.close')" @click="close" />
      </template>
    </ALModal>
  </Teleport>
</template>
